var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_1_",
    transform: "translate(32 77.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    transform: "translate(-0.001 27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    transform: "translate(0 0)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    className: "st1",
    d: "M474.6,103.3L231.9-74.5c-4.7-3.4-11-3.4-15.7,0L-26.5,103.3c-5.9,4.3-7.2,12.7-2.9,18.6 c4.3,5.9,12.7,7.2,18.6,2.9L224-47.2l234.8,172c5.9,4.3,14.3,3,18.6-2.9C481.8,115.9,480.5,107.6,474.6,103.3L474.6,103.3 L474.6,103.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    transform: "translate(1.502 33.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    className: "st1",
    d: "M408.8,122.2c-7.3,0-13.3,6-13.3,13.3l0,0v211.8H289.1V231.7c0-36.7-29.8-66.5-66.5-66.5 c-36.7,0-66.5,29.8-66.5,66.5v115.6H49.6V135.6c0-7.3-6-13.3-13.3-13.3s-13.3,6-13.3,13.3v225.1c0,7.3,6,13.3,13.3,13.3h0h133 c7,0,12.7-5.4,13.3-12.3c0-0.4,0-0.7,0-1.1V231.7c0.7-22,19.1-39.4,41.1-38.7c21.1,0.6,38,17.6,38.7,38.7v128.9c0,0.3,0,0.7,0,1 c0.5,6.9,6.3,12.3,13.3,12.3h133c7.3,0,13.3-6,13.3-13.3l0,0v-225C422.1,128.2,416.2,122.2,408.8,122.2 C408.8,122.2,408.8,122.2,408.8,122.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.518527073452c3660119bcfc3adf4c26.svg";
export { ForwardRef as ReactComponent };